import axios from "axios";
import API from "../_helpers/endpointService";

export const getSettingsFormat = (data) => {
    let apiUrl = API.SETTINGS_PROJECT + data;
    return (dispatch) => {
      axios({
        method: "get",
        url: apiUrl,
        data: data,
      })
        .then((response) => {
          if (response?.status === 200) {
            dispatch({ type: "SETTINGS", data: response.data });
          } else {
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
          }
        });
    };
};